import HeroSection2 from './HeroSection2';

export default HeroSection2;